import { createBrowserRouter } from "react-router-dom";

import adminRoutes from "./admin-router";
import NotFound from "./components/NotFound";
import CrmAddons from "./pages/crm/addons";
import CrmAddonsCreate from "./pages/crm/addons-create";
import CrmAddonsEdit from "./pages/crm/addons-edit";
import Crm from "./pages/crm/crm";
import CrmCustomerDetail from "./pages/crm/customer-detail";
import CrmCustomers from "./pages/crm/customers";
import CrmHelp from "./pages/crm/help";
import CrmIntegrations from "./pages/crm/integrations";
import CrmLocations from "./pages/crm/locations";
import CrmOrders from "./pages/crm/orders";
import CrmOrdersEdit from "./pages/crm/orders-edit";
import CrmPrivileges from "./pages/crm/privileges";
import CrmPrivilegesCreate from "./pages/crm/privileges-create";
import CrmPrivilegesEdit from "./pages/crm/privileges-edit";
import CrmProductMaster from "./pages/crm/product-master";
import CrmProductMasterCreate from "./pages/crm/product-master-create";
import CrmProductMasterEdit from "./pages/crm/product-master-edit";
import CrmRedemptions from "./pages/crm/redemptions";
import CrmReports from "./pages/crm/reports";
import Dashboard from "./pages/dashboard";
import DashboardV2 from "./pages/dashboard-v2";
import EssilorComponent from "./pages/essilor-components";
import Login from "./pages/login";
import userRoutes from "./user-router";

export const routes = [
  {
    path: "",
    element: <Login />,
  },
  {
    path: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "dashboard/v2",
    element: <DashboardV2 />,
  },
  {
    path: "crm",
    element: <Crm />,
    children: [
      {
        path: "",
        element: <CrmCustomers />,
      },
      {
        path: "customers",
        element: <CrmCustomers />,
      },
      {
        path: "customers/:id",
        element: <CrmCustomerDetail />,
      },
      {
        path: "locations",
        element: <CrmLocations />,
      },
      {
        path: "orders",
        element: <CrmOrders />,
      },
      {
        path: "orders/:id/edit",
        element: <CrmOrdersEdit />,
      },
      {
        path: "product-master",
        element: <CrmProductMaster />,
      },
      {
        path: "product-master/create",
        element: <CrmProductMasterCreate />,
      },
      {
        path: "product-master/:id/edit",
        element: <CrmProductMasterEdit />,
      },
      {
        path: "integrations",
        element: <CrmIntegrations />,
      },
      {
        path: "privileges",
        element: <CrmPrivileges />,
      },
      {
        path: "privileges/create",
        element: <CrmPrivilegesCreate />,
      },
      {
        path: "privileges/:id/edit",
        element: <CrmPrivilegesEdit />,
      },
      {
        path: "redemptions",
        element: <CrmRedemptions />,
      },
      {
        path: "addons",
        element: <CrmAddons />,
      },
      {
        path: "addons/create",
        element: <CrmAddonsCreate />,
      },
      {
        path: "addons/:id/edit",
        element: <CrmAddonsEdit />,
      },
      {
        path: "reports",
        element: <CrmReports />,
      },
      {
        path: "help",
        element: <CrmHelp />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
  {
    path: "components",
    element: <EssilorComponent />,
  },
  ...adminRoutes,
  ...userRoutes,
  {
    path: "*",
    element: <NotFound fullScreen />,
  },
];

const router = createBrowserRouter(routes);

export default router;
